<template>
  <div class="notification-table">
    <v-row no-gutters class="mb-2">
      <v-col cols="12" class="pa-1">
        <span class="font-weight-bold">รายการแจ้งปรับปรุงข้อมูล</span>
        
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1 mt-2"
          no-data-text="ไม่มีรายการแจ้งปรับปรุงข้อมูล"
        >
          <!-- สถานะ -->
          <template v-slot:item.personnel_temporary_notifyStatus="{ item }">
            <v-chip
              :color="getStatusColor(item.personnel_temporary_notifyStatus)"
              dark
            >
              {{ getStatusText(item.personnel_temporary_notifyStatus) }}
            </v-chip>
          </template>

          <!-- ปุ่มยกเลิก -->
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.personnel_temporary_notifyStatus === 'send'"
              color="warning"
              rounded
              small
              @click="$emit('delete-notification', item.personnel_temporary_notifyID)"
            >
              <v-icon left small>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "NotificationTable",
  
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      headers: [
        { text: "วิทยาลัย", align: "left", value: "personnel_temporary_notifyCollegeCode" },
        { text: "ชื่อนามสกุล", align: "left", value: "frist_names" },
        { text: "รายละเอียด", align: "left", value: "personnel_temporary_notifyDetail" },
        { text: "สถานะ", align: "left", value: "personnel_temporary_notifyStatus" },
        { text: "วันที่ร้องขอ", align: "left", value: "personnel_temporary_notifyDateTIme" },
        { text: "ดำเนินการ", align: "center", value: "actions" }
      ]
    };
  },

  methods: {
    getStatusColor(status) {
      const colors = {
        send: "red",
        update: "primary"
      };
      return colors[status] || "grey";
    },

    getStatusText(status) {
      const texts = {
        send: "รอดำเนินการ",
        update: "เสร็จสิ้น"
      };
      return texts[status] || status;
    }
  }
};
</script>

<style scoped>
.notification-table {
  margin-bottom: 24px;
}
</style>